var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"padding-a-8 fill-height align-start",style:(_vm.styles),attrs:{"fluid":""}},[_c('div',{staticClass:"w-full",class:{ 'h-full': _vm.fullHeight }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }